(function() {
'use strict';
const header = document.querySelector('.header');
if (header) {
window.addEventListener('scroll', () => {
if (window.scrollY > 100) {
header.classList.add('scrolled');
} else {
header.classList.remove('scrolled');
}
});
}
const cartTrigger = document.getElementById('cartTrigger');
const cartDrawer = document.getElementById('cartDrawer');
const cartOverlay = document.getElementById('cartOverlay');
const cartClose = document.getElementById('cartClose');
function openCart() {
if (cartDrawer && cartOverlay) {
cartDrawer.classList.add('active');
cartOverlay.classList.add('active');
document.body.style.overflow = 'hidden';
}
}
function closeCart() {
if (cartDrawer && cartOverlay) {
cartDrawer.classList.remove('active');
cartOverlay.classList.remove('active');
document.body.style.overflow = '';
}
}
if (cartTrigger) cartTrigger.addEventListener('click', openCart);
if (cartClose) cartClose.addEventListener('click', closeCart);
if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
const searchTrigger = document.getElementById('searchTrigger');
const searchPanel = document.getElementById('searchPanel');
const searchOverlay = document.getElementById('searchOverlay');
const searchClose = document.getElementById('searchClose');
const searchInput = document.getElementById('searchInput');
let searchTimeout;
function openSearch() {
if (searchPanel && searchOverlay && searchTrigger) {
clearTimeout(searchTimeout);
searchPanel.classList.add('active');
searchOverlay.classList.add('active');
searchTrigger.classList.add('active');
if (searchInput) {
setTimeout(() => searchInput.focus(), 100);
}
}
}
function closeSearch() {
if (searchPanel && searchOverlay && searchTrigger) {
searchPanel.classList.remove('active');
searchOverlay.classList.remove('active');
searchTrigger.classList.remove('active');
if (searchInput) searchInput.value = '';
}
}
function scheduleCloseSearch() {
clearTimeout(searchTimeout);
searchTimeout = setTimeout(closeSearch, 200);
}
if (searchTrigger) {
searchTrigger.addEventListener('mouseenter', openSearch);
searchTrigger.addEventListener('click', openSearch);
searchTrigger.addEventListener('mouseleave', scheduleCloseSearch);
}
if (searchPanel) {
searchPanel.addEventListener('mouseenter', openSearch);
searchPanel.addEventListener('mouseleave', scheduleCloseSearch);
}
if (searchOverlay) {
searchOverlay.addEventListener('mouseenter', closeSearch);
searchOverlay.addEventListener('click', closeSearch);
}
if (searchClose) searchClose.addEventListener('click', closeSearch);
document.addEventListener('keydown', (e) => {
if (e.key === 'Escape') {
closeSearch();
closeCart();
}
});
const fadeElements = document.querySelectorAll('.fade-in');
if (fadeElements.length > 0) {
const observerOptions = {
threshold: 0.1,
rootMargin: '0px 0px -50px 0px'
};
const observer = new IntersectionObserver((entries) => {
entries.forEach((entry, index) => {
if (entry.isIntersecting) {
setTimeout(() => {
entry.target.classList.add('visible');
}, index * 100);
}
});
}, observerOptions);
fadeElements.forEach(el => observer.observe(el));
}
const accordionHeaders = document.querySelectorAll('.accordion-header');
accordionHeaders.forEach(header => {
header.addEventListener('click', () => {
const item = header.parentElement;
item.classList.toggle('active');
});
});
const thumbnails = document.querySelectorAll('.thumbnail');
const mainImages = document.querySelectorAll('.main-image');
thumbnails.forEach(thumb => {
thumb.addEventListener('click', () => {
const index = parseInt(thumb.dataset.index);
thumbnails.forEach(t => t.classList.remove('active'));
thumb.classList.add('active');
if (mainImages[index]) {
mainImages[index].scrollIntoView({ behavior: 'smooth', block: 'start' });
}
});
});
window.animateCartIcon = function() {
const cartTrigger = document.getElementById('cartTrigger');
if (cartTrigger) {
cartTrigger.classList.remove('cart-pulse');
void cartTrigger.offsetWidth;
cartTrigger.classList.add('cart-pulse');
setTimeout(() => cartTrigger.classList.remove('cart-pulse'), 450);
}
const cartCount = document.querySelector('.cart-count');
if (cartCount) {
cartCount.classList.remove('badge-pulse');
void cartCount.offsetWidth;
cartCount.classList.add('badge-pulse');
setTimeout(() => cartCount.classList.remove('badge-pulse'), 550);
}
};
window.addToCart = function(variantId, quantity = 1) {
return fetch('/cart/add.js', {
method: 'POST',
headers: {
'Content-Type': 'application/json',
},
body: JSON.stringify({
id: variantId,
quantity: quantity
})
})
.then(response => response.json())
.then(data => {
refreshCartDrawer();
openCart();
return data;
})
.catch(error => {
console.error('Error adding to cart:', error);
});
};
window.updateCartItem = function(line, quantity) {
return fetch('/cart/change.js', {
method: 'POST',
headers: {
'Content-Type': 'application/json',
},
body: JSON.stringify({
line: line,
quantity: quantity
})
})
.then(response => response.json())
.then(data => {
refreshCartDrawer();
return data;
});
};
window.refreshCartDrawer = function() {
fetch('/?section_id=cart-drawer-content')
.then(response => response.text())
.then(html => {
const cartContent = document.getElementById('cartContent');
if (cartContent) {
const parser = new DOMParser();
const doc = parser.parseFromString(html, 'text/html');
const sectionContent = doc.querySelector('.shopify-section');
if (sectionContent) {
cartContent.innerHTML = sectionContent.innerHTML;
} else {
cartContent.innerHTML = html;
}
attachCartEventListeners();
}
fetch('/cart.js')
.then(response => response.json())
.then(cart => {
const cartTrigger = document.getElementById('cartTrigger');
let cartCount = document.querySelector('.cart-count');
if (cart.item_count > 0) {
if (cartCount) {
cartCount.textContent = `(${cart.item_count})`;
cartCount.style.display = '';
} else if (cartTrigger) {
const countSpan = document.createElement('span');
countSpan.className = 'cart-count';
countSpan.textContent = `(${cart.item_count})`;
cartTrigger.appendChild(countSpan);
}
} else if (cartCount) {
cartCount.remove();
}
if (typeof window.animateCartIcon === 'function') {
window.animateCartIcon();
}
});
})
.catch(error => {
console.error('Error refreshing cart:', error);
});
};
function attachCartEventListeners() {
const cartItems = document.querySelectorAll('.cart-item');
cartItems.forEach(item => {
const line = parseInt(item.dataset.line);
const qtyBtns = item.querySelectorAll('.qty-btn');
const removeBtn = item.querySelector('[data-action="remove"]');
qtyBtns.forEach(btn => {
btn.addEventListener('click', () => {
const action = btn.dataset.action;
const currentQty = parseInt(item.querySelector('.cart-item-quantity span').textContent);
let newQty = currentQty;
if (action === 'increase') {
newQty++;
} else if (action === 'decrease') {
newQty = Math.max(0, currentQty - 1);
}
updateCartItem(line, newQty);
});
});
if (removeBtn) {
removeBtn.addEventListener('click', () => {
updateCartItem(line, 0);
});
}
});
}
window.attachCartEventListeners = attachCartEventListeners;
attachCartEventListeners();
})();
if (typeof Shopify === 'undefined') {
window.Shopify = {};
}
if (typeof Shopify.formatMoney !== 'function') {
Shopify.formatMoney = function(cents, format) {
if (typeof cents === 'string') {
cents = cents.replace('.', '');
}
var value = '';
var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
var formatString = format || (window.theme && window.theme.moneyFormat) || '{{amount}} CHF';
function formatWithDelimiters(number, precision, thousands, decimal) {
precision = precision || 2;
thousands = thousands || "'";
decimal = decimal || '.';
if (isNaN(number) || number == null) {
return 0;
}
number = (number / 100.0).toFixed(precision);
var parts = number.split('.');
var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
var centsAmount = parts[1] ? decimal + parts[1] : '';
return dollarsAmount + centsAmount;
}
var match = formatString.match(placeholderRegex);
if (!match) {
return formatWithDelimiters(cents, 2) + ' CHF';
}
switch (match[1]) {
case 'amount':
value = formatWithDelimiters(cents, 2);
break;
case 'amount_no_decimals':
value = formatWithDelimiters(cents, 0);
break;
case 'amount_with_comma_separator':
value = formatWithDelimiters(cents, 2, '.', ',');
break;
case 'amount_no_decimals_with_comma_separator':
value = formatWithDelimiters(cents, 0, '.', ',');
break;
case 'amount_with_apostrophe_separator':
value = formatWithDelimiters(cents, 2, "'", '.');
break;
default:
value = formatWithDelimiters(cents, 2);
}
return formatString.replace(placeholderRegex, value);
};
}
document.addEventListener('click', function(e) {
const navArrow = e.target.closest('.product-nav-arrow');
if (navArrow) {
e.preventDefault();
e.stopPropagation();
const wrapper = navArrow.closest('.product-image-wrapper');
const slider = wrapper.querySelector('.product-gallery-slider');
const images = Array.from(slider.querySelectorAll('.product-slide-image'));
const imageCount = images.length;
if (imageCount <= 1) return;
slider.classList.add('navigated');
const currentImage = slider.querySelector('.product-slide-image.active');
let currentIndex = 0;
images.forEach((img, idx) => {
if (img.classList.contains('active')) {
currentIndex = idx;
}
});
let newIndex;
if (navArrow.classList.contains('product-nav-prev')) {
newIndex = currentIndex === 0 ? imageCount - 1 : currentIndex - 1;
} else {
newIndex = currentIndex === imageCount - 1 ? 0 : currentIndex + 1;
}
const newImage = images[newIndex];
if (newImage) {
if (newImage.loading === 'lazy') {
newImage.loading = 'eager';
}
if (!newImage.complete) {
newImage.addEventListener('load', function() {
showImage();
}, { once: true });
} else {
showImage();
}
function showImage() {
images.forEach(img => img.classList.remove('active', 'hover-image'));
newImage.classList.add('active');
}
}
}
});
document.addEventListener('mouseleave', function(e) {
if (e.target.classList && e.target.classList.contains('product-card')) {
const slider = e.target.querySelector('.product-gallery-slider');
if (slider && slider.classList.contains('navigated')) {
slider.classList.remove('navigated');
const images = Array.from(slider.querySelectorAll('.product-slide-image'));
images.forEach((img, index) => {
img.classList.remove('active', 'hover-image');
if (index === 0) {
img.classList.add('active');
} else if (index === 1 && images.length > 1) {
img.classList.add('hover-image');
}
});
}
}
}, true);
document.addEventListener('click', function(e) {
const quickAddBtn = e.target.closest('.quick-size-btn');
if (quickAddBtn && !quickAddBtn.classList.contains('unavailable') && !quickAddBtn.disabled) {
e.preventDefault();
e.stopPropagation();
const variantId = quickAddBtn.dataset.variantId;
if (!variantId) return;
const productCard = quickAddBtn.closest('.product-card');
const imageWrapper = productCard.querySelector('.product-image-wrapper');
const cartTrigger = document.getElementById('cartTrigger');
quickAddBtn.classList.add('added');
const flyingEl = document.createElement('div');
flyingEl.className = 'flying-to-cart';
flyingEl.textContent = quickAddBtn.textContent;
const btnRect = quickAddBtn.getBoundingClientRect();
const cartRect = cartTrigger ? cartTrigger.getBoundingClientRect() : { left: window.innerWidth - 50, top: 30 };
flyingEl.style.cssText = `
left: ${btnRect.left + btnRect.width / 2}px;
top: ${btnRect.top + btnRect.height / 2}px;
`;
document.body.appendChild(flyingEl);
const deltaX = cartRect.left + cartRect.width / 2 - (btnRect.left + btnRect.width / 2);
const deltaY = cartRect.top + cartRect.height / 2 - (btnRect.top + btnRect.height / 2);
requestAnimationFrame(() => {
flyingEl.style.setProperty('--fly-x', `${deltaX}px`);
flyingEl.style.setProperty('--fly-y', `${deltaY}px`);
flyingEl.classList.add('flying');
});
fetch('/cart/add.js', {
method: 'POST',
headers: {
'Content-Type': 'application/json',
},
body: JSON.stringify({
id: variantId,
quantity: 1
})
})
.then(response => response.json())
.then(data => {
const successEl = document.createElement('div');
successEl.className = 'quick-add-success';
successEl.innerHTML = '<svg viewBox="0 0 24 24"><path d="M5 13l4 4L19 7"/></svg>';
imageWrapper.appendChild(successEl);
setTimeout(() => {
flyingEl.remove();
}, 600);
fetch('/cart.js')
.then(r => r.json())
.then(cart => {
let cartCount = document.querySelector('.cart-count');
if (cartCount) {
cartCount.textContent = '(' + cart.item_count + ')';
} else if (cartTrigger) {
const countSpan = document.createElement('span');
countSpan.className = 'cart-count';
countSpan.textContent = '(' + cart.item_count + ')';
cartTrigger.appendChild(countSpan);
}
setTimeout(() => {
if (typeof window.animateCartIcon === 'function') {
window.animateCartIcon();
}
}, 600);
updateCartDrawerContent();
});
setTimeout(() => {
successEl.classList.add('fade-out');
setTimeout(() => {
successEl.remove();
quickAddBtn.classList.remove('added');
}, 300);
}, 1200);
})
.catch(error => {
console.error('Error:', error);
flyingEl.remove();
quickAddBtn.classList.remove('added');
const errorEl = document.createElement('div');
errorEl.className = 'quick-add-success';
errorEl.innerHTML = '<svg viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"/></svg>';
imageWrapper.appendChild(errorEl);
setTimeout(() => {
errorEl.classList.add('fade-out');
setTimeout(() => errorEl.remove(), 300);
}, 1200);
});
}
});
function updateCartDrawerContent() {
const cartContent = document.getElementById('cartContent');
if (!cartContent) return;
fetch('/cart?view=drawer-content')
.then(r => r.text())
.then(html => {
const parser = new DOMParser();
const doc = parser.parseFromString(html, 'text/html');
const newContent = doc.querySelector('.cart-drawer-content');
if (newContent) {
cartContent.innerHTML = newContent.innerHTML;
if (typeof window.attachCartEventListeners === 'function') {
window.attachCartEventListeners();
}
}
})
.catch(err => {
fetch('/cart.js')
.then(r => r.json())
.then(cart => {
const cartCount = document.querySelector('.cart-count');
if (cartCount) {
cartCount.textContent = '(' + cart.item_count + ')';
}
const subtotalEl = document.querySelector('[data-cart-total]');
if (subtotalEl && window.Shopify && window.Shopify.formatMoney) {
subtotalEl.textContent = Shopify.formatMoney(cart.total_price);
}
});
});
}
const Wishlist = {
storageKey: 'brandrise_wishlist',
getItems: function() {
const items = localStorage.getItem(this.storageKey);
return items ? JSON.parse(items) : [];
},
saveItems: function(items) {
localStorage.setItem(this.storageKey, JSON.stringify(items));
},
addItem: function(productId, productHandle) {
const items = this.getItems();
if (!items.find(item => item.id === productId)) {
items.push({ id: productId, handle: productHandle });
this.saveItems(items);
}
return items;
},
removeItem: function(productId) {
let items = this.getItems();
items = items.filter(item => item.id !== productId);
this.saveItems(items);
return items;
},
hasItem: function(productId) {
return this.getItems().some(item => item.id === productId);
},
toggle: function(productId, productHandle) {
if (this.hasItem(productId)) {
this.removeItem(productId);
return false;
} else {
this.addItem(productId, productHandle);
return true;
}
},
getCount: function() {
return this.getItems().length;
}
};
function updateWishlistCount() {
const countEl = document.querySelector('.wishlist-count');
if (countEl) {
const count = Wishlist.getCount();
countEl.textContent = '(' + count + ')';
countEl.style.display = count > 0 ? 'inline' : 'none';
}
}
document.addEventListener('DOMContentLoaded', function() {
document.querySelectorAll('.product-wishlist').forEach(btn => {
const productId = btn.dataset.productId;
if (productId && Wishlist.hasItem(productId)) {
btn.classList.add('active');
}
});
updateWishlistCount();
});
document.addEventListener('click', function(e) {
const wishlistBtn = e.target.closest('.product-wishlist');
if (wishlistBtn) {
e.preventDefault();
e.stopPropagation();
const productId = wishlistBtn.dataset.productId;
const productHandle = wishlistBtn.dataset.productHandle;
if (!productId) return;
const isAdded = Wishlist.toggle(productId, productHandle);
wishlistBtn.classList.toggle('active', isAdded);
updateWishlistCount();
if (isAdded) {
const wishlistTrigger = document.getElementById('wishlistTrigger');
if (wishlistTrigger) {
const flyingHeart = document.createElement('div');
flyingHeart.className = 'flying-to-wishlist';
flyingHeart.innerHTML = `
<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5">
<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
</svg>
`;
const btnRect = wishlistBtn.getBoundingClientRect();
const wishlistRect = wishlistTrigger.getBoundingClientRect();
flyingHeart.style.cssText = `
left: ${btnRect.left + btnRect.width / 2}px;
top: ${btnRect.top + btnRect.height / 2}px;
`;
document.body.appendChild(flyingHeart);
const deltaX = wishlistRect.left + wishlistRect.width / 2 - (btnRect.left + btnRect.width / 2);
const deltaY = wishlistRect.top + wishlistRect.height / 2 - (btnRect.top + btnRect.height / 2);
requestAnimationFrame(() => {
flyingHeart.style.setProperty('--fly-x', `${deltaX}px`);
flyingHeart.style.setProperty('--fly-y', `${deltaY}px`);
flyingHeart.classList.add('flying');
});
wishlistTrigger.classList.add('pulse');
setTimeout(() => {
flyingHeart.remove();
wishlistTrigger.classList.remove('pulse');
}, 800);
}
wishlistBtn.style.transform = 'scale(1.3)';
setTimeout(() => {
wishlistBtn.style.transform = '';
}, 200);
} else {
wishlistBtn.style.transform = 'scale(0.8)';
setTimeout(() => {
wishlistBtn.style.transform = '';
}, 200);
}
}
});
(function() {
if (window.innerWidth > 768) return;
document.addEventListener('click', function(e) {
var card = e.target.closest('.product-card');
var quickBtn = e.target.closest('.quick-size-btn');
var navArrow = e.target.closest('.product-nav-arrow');
var wishlistBtn = e.target.closest('.product-wishlist');
if (quickBtn || navArrow || wishlistBtn) return;
if (card) {
var bar = card.querySelector('.quick-add-sizes-bar');
if (!bar) return;
var isVisible = card.classList.contains('quick-add-visible');
document.querySelectorAll('.product-card.quick-add-visible').forEach(function(c) {
if (c !== card) c.classList.remove('quick-add-visible');
});
if (!isVisible) {
e.preventDefault();
card.classList.add('quick-add-visible');
}
}
});
var scrollTimer;
window.addEventListener('scroll', function() {
clearTimeout(scrollTimer);
scrollTimer = setTimeout(function() {
document.querySelectorAll('.product-card.quick-add-visible').forEach(function(c) {
c.classList.remove('quick-add-visible');
});
}, 100);
}, { passive: true });
})();
(function() {
if (window.innerWidth > 768) return;
var gallery = document.querySelector('.product-gallery-wrapper .product-gallery-scroll');
if (!gallery) return;
var images = gallery.querySelectorAll('.gallery-image-scroll');
if (images.length <= 1) return;
var dotsWrap = document.createElement('div');
dotsWrap.className = 'gallery-scroll-dots';
dotsWrap.style.cssText = 'display:flex;justify-content:center;gap:6px;padding:12px 0 4px;';
for (var i = 0; i < images.length; i++) {
var dot = document.createElement('span');
dot.style.cssText = 'width:6px;height:6px;border-radius:50%;background:#ccc;transition:background 0.2s,transform 0.2s;';
if (i === 0) { dot.style.background = '#000'; dot.style.transform = 'scale(1.2)'; }
dotsWrap.appendChild(dot);
}
gallery.parentElement.appendChild(dotsWrap);
var dots = dotsWrap.querySelectorAll('span');
gallery.addEventListener('scroll', function() {
var scrollLeft = gallery.scrollLeft;
var itemWidth = gallery.scrollWidth / images.length;
var activeIndex = Math.round(scrollLeft / itemWidth);
dots.forEach(function(d, idx) {
if (idx === activeIndex) {
d.style.background = '#000';
d.style.transform = 'scale(1.2)';
} else {
d.style.background = '#ccc';
d.style.transform = 'scale(1)';
}
});
}, { passive: true });
})();